import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const LockIcon = memo(() => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="currentColor"
        // eslint-disable-next-line max-len
        d="M3.533 13.8V6.2h2V4.867c0-.69.24-1.273.717-1.75A2.38 2.38 0 0 1 8 2.4a2.38 2.38 0 0 1 1.75.717 2.38 2.38 0 0 1 .717 1.75V6.2h2v7.6H3.533ZM4 13.333h8V6.667H4v6.666ZM8 10.9c.256 0 .47-.086.642-.258A.871.871 0 0 0 8.9 10a.871.871 0 0 0-.258-.642A.871.871 0 0 0 8 9.1a.871.871 0 0 0-.642.258A.871.871 0 0 0 7.1 10c0 .256.086.47.258.642A.871.871 0 0 0 8 10.9ZM6 6.2h4V4.867c0-.556-.194-1.028-.583-1.417A1.929 1.929 0 0 0 8 2.867c-.556 0-1.028.194-1.417.583A1.929 1.929 0 0 0 6 4.867V6.2Z"
      />
    </svg>
  </IconWrapper>
));
